<template>
    <div>
        <div class="dialog-footer" style="text-align: right;margin-bottom: 10px">
            <el-button size="small" type="danger" @click="saveData()">
                {{form.id == '' ? '下一步' : '保 存'}}

            </el-button>
        </div>
        <el-form :model="form" :rules="rules" ref="form" label-width="160px">

            <el-form-item label="活动选择" >
                <el-select v-model="form.bindCode" clearable filterable placeholder="活动选择">
                    <el-option
                            v-for="item in activeOptions"
                            :key="item.bindCode"
                            :label="item.activeName"
                            :value="item.bindCode">
                    </el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="抽奖名称" prop="luckyDrawName">
                <el-input v-model="form.luckyDrawName" placeholder="抽奖名称"></el-input>
            </el-form-item>

          <el-form-item label="预约类型" >
            <el-select v-model="form.userType" clearable filterable placeholder="预约类型">
              <el-option
                  v-for="item in userType"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id">
              </el-option>
            </el-select>
          </el-form-item>

            <el-form-item label="期次" prop="period" >
                <el-input-number v-model="form.period" :min="1" :max="10000"
                                 placeholder="期次" disabled="disabled"></el-input-number>
            </el-form-item>

            <el-form-item label="开始时间" prop="beginTime">
                <el-date-picker
                        v-model="form.beginTime"
                        type="datetime"
                        value-format="yyyy-MM-dd HH:mm:ss"
                        placeholder="选择抽奖活动开始时间">
                </el-date-picker>
            </el-form-item>

            <el-form-item label="结束时间" prop="endTime">
                <el-date-picker
                        v-model="form.endTime"
                        type="datetime"
                        value-format="yyyy-MM-dd HH:mm:ss"
                        placeholder="选择抽奖活动结束时间">
                </el-date-picker>
            </el-form-item>
            <el-form-item label="开奖时间" prop="openTime">
                <el-date-picker
                        v-model="form.openTime"
                        type="datetime"
                        value-format="yyyy-MM-dd HH:mm:ss"
                        placeholder="选择抽奖活动开奖时间">
                </el-date-picker>
            </el-form-item>

            <el-form-item label="备注" prop="remark">
                <el-input v-model="form.remark" placeholder="备注"></el-input>
            </el-form-item>

        </el-form>
    </div>


</template>
<script>
    //导入 HTTP请求方法
    import {
        getActiveForOptionListByType, luckydraw_get, luckydraw_add, getActive
    } from '../../api/api';

    import ElDialog from "../../../node_modules/element-ui/packages/dialog/src/component";
    export default {
        components: {ElDialog}, data() {
            var validateDate = (rule, value, callback) => {
                if (value === '') {
                    callback(new Error('请选择日期'));
                } else if (value <= this.form.beginTime) {
                    callback(new Error('结束日期不能小于开始日期!'));
                } else {
                    callback();
                }
            };
            var validateDate2 = (rule, value, callback) => {
                if (value === '') {
                    callback(new Error('请选择日期'));
                } else if (value >= this.form.endTime) {
                    callback(new Error('结束日期不能小于开始日期!'));
                } else {
                    callback();
                }
            };
            var validateDate3 = (rule, value, callback) => {
                if (value === '') {
                    callback(new Error('请选择日期'));
                } else if (value <= this.form.endTime) {
                    callback(new Error('开奖日期不能小于结束日期!'));
                } else {
                    callback();
                }
            };
            return {
                rules: {
                    luckyDrawName: [
                        {required: true, message: '请输入抽奖名称', trigger: 'blur'},
                        {min: 1, max: 20, message: '长度在 1 到 40 个字符', trigger: 'blur'}
                    ],
                    beginTime: [
                        {type: 'string', required: true, message: '请选择开始日期', trigger: 'change'}
                    ],
                    endTime: [
                        {type: 'string', required: true, message: '请选择结束日期', trigger: 'change'},
                        {validator: validateDate, trigger: 'blur'}
                    ],
                    openTime: [
                        {type: 'string', required: true, message: '请选择开奖日期', trigger: 'change'},
                        {validator: validateDate3, trigger: 'blur'}
                    ],

                    period: [
                        {type: 'number', message: '必须为数字'}
                    ],

                },
                form: {
                    id:this.$route.query.id,
                    luckyDrawName:'',
                    bindCode: this.$route.query.bindCode,
                    period:1,
                    beginTime:'',
                    endTime:'',
                    baseCount:0,
                    status:0,
                    openTime:'',
                    remark:'',
                  userType:0,
                },
                activeOptions: [],
                userType:[{id:0,name:'所有用户可预约'},{id:1,name:'下单用户可预约'},{id:2,name:'新用户可预约'}],
            };

        },
        //props:['activeParam'],
        //挂载时候执行
        mounted(){
            //初始化首页数据
            getActiveForOptionListByType({activeType:39}).then((res) => {
                this.activeOptions = res.data.value;
                this.form.bindCode=res.data.value[0].bindCode;
                this.getEntity();
            });



        },
        computed: {},
        methods: {
            getEntity(){
                if(this.form.id!=''&&this.form.id!=null) {
                    console.log("id:"+this.form.id);
                    luckydraw_get({id: this.form.id}).then(res => {
                        this.form = res.data.value;
                    });
                }
            },
            saveData(){
                this.$refs.form.validate((valid)=>{
                   if(valid){
                       this.loading = true;
                       luckydraw_add(this.form).then((res) => {
                           this.loading = false;
                           if (res.data.status == 200) {
                               this.showDialog = false;
                               this.$message({
                                   message: '保存成功',
                                   type: 'success'
                               });

                               if (this.form.id == ''||this.form.id==null) {
                                   this.form = res.data.value;
                                  editeActive(this.form);
                               }

                           } else {
                               this.$message({
                                   showClose: true,
                                   message: res.data.message,
                                   type: 'error'
                               });
                           }
                       });
                   }else{
                        //验证不通过
                   }
                });

            },
            editeActive(row){
                this.$router.replace({
                    path: '/lucky/luckytabs',
                    name: 'luckytabs',
                    query: {
                        bindCode: row.bindCode,
                        luckyDrawName: row.luckyDrawName,
                        id:row.id,
                        curTab: "tab1",
                    }
                })
            },

        }
    }
</script>


// WEBPACK FOOTER //
// src/views/lucky/luckydrawEdit.vue